const FETCH_NETWORK_DEVICE_VERSIONS = "network::fetch::device-versions";

export { FETCH_NETWORK_DEVICE_VERSIONS };
